import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { StateManagementService } from "providers/state-management/state-management.service";
import { Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { PlanOfCareDataService } from "../../../providers/poc-data-service/poc-data-service";

/**
 * Generated class for the ActivePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-active-issues",
  templateUrl: "active-issues.html",
})
export class ActiveIssuesPage {
  activeIssues: any = {};
  selectedData: object = null;
  taskCount = 0;
  private addPocIssue: boolean;
  private subscriptions = new Subscription();
  constructor(
    private dataService: PlanOfCareDataService,
    public navCtrl: NavController,
    public navParams: NavParams,
    public stateData: StateManagementService
  ) {}

  ionViewWillEnter() {
    // SUP-19982: takeUntil(logout$) releases this before resetState() broadcasts
    // addPocIssue.next(null) on sign-out, which otherwise made every accumulated
    // subscription re-issue getIssues(). Tracked + released in ionViewWillLeave so
    // re-entering the tab does not stack another subscriber.
    this.subscriptions.add(
      this.stateData.addPocIssue
        .pipe(takeUntil(this.stateData.logout$))
        .subscribe((x) => {
          if (x !== null) {
            this.addPocIssue = x;
          }
          this.getIssues();
        })
    );
    this.dataService.getIssuesCount();
    this.subscriptions.add(
      this.dataService
        .getIssueUpdated()
        .pipe(takeUntil(this.stateData.logout$))
        .subscribe((data) => {
          this.getIssues();
          this.dataService.getIssuesCount();
        })
    );
  }

  ionViewWillLeave() {
    this.subscriptions.unsubscribe();
    this.subscriptions = new Subscription();
  }

  select(data) {
    this.selectedData = this.selectedData === data ? null : data;
  }

  updateIssuesList(event: { action: string; data: any; newData?: any }) {
    let action = event.action,
      data = event.data;

    if (event.newData !== null && event.newData !== undefined) {
      if (action === "addGoal") {
        let index = this.activeIssues.issues.indexOf(data);
        if (index > -1) {
          //TODO confirm event.newData is in the correct format to be read as a new goal
          for (let newGoal of event.newData["goals"]) {
            this.activeIssues.issues[index].goals.push(newGoal);
          }
        }
      }
      if (action === "addIntervention") {
        for (let issue of this.activeIssues.issues) {
          let goalIndex = issue.goals.indexOf(data);
          if (goalIndex > -1) {
            //TODO confirm event.newData is in the correct format to be read as a new intervention
            for (let newIntervention of event.newData["interventions"]) {
              issue.goals[goalIndex].interventions.push(newIntervention);
            }
          }
        }
      }
    }

    if (action === "resolveIssue") {
      let index = this.activeIssues.issues.indexOf(data);
      this.activeIssues.issues.splice(index, 1);
      if (this.selectedData === data) {
        this.selectedData = null;
      }
    }

    if (action === "resolveTask") {
      let index = this.activeIssues.tasks.indexOf(data);
      this.activeIssues.tasks.splice(index, 1);
      this.taskCount = this.activeIssues.tasks.length;
      if (this.selectedData === data) {
        this.selectedData = null;
      }
    }

    if (action === "meetGoal" || action === "discontinueGoal") {
      for (let issue of this.activeIssues.issues) {
        let goalIndex = issue.goals.indexOf(data);
        if (goalIndex > -1) {
          issue.goals.splice(goalIndex, 1);
          if (this.selectedData === data) {
            this.selectedData = null;
          }
          break;
        }
      }
    }
    if (action === "discontinueIntervention") {
      for (let issue of this.activeIssues.issues) {
        for (let goal of issue.goals) {
          let interventionIndex = goal.interventions.indexOf(data);
          if (interventionIndex > -1) {
            goal.interventions.splice(interventionIndex, 1);
            if (this.selectedData === data) {
              this.selectedData = null;
            }
            break;
          }
        }
      }
    }
  }

  getIssues() {
    let getIssues = this.addPocIssue
      ? this.dataService.getIssuesWithPermissions("CL007.2")
      : this.dataService.getIssues("CL007.2");

    getIssues.subscribe(
      (data) => {
        this.activeIssues = data;
        let actIssue: activeIssue = new activeIssue();
        Object.assign(actIssue, data);
        if (actIssue.tasks) {
          this.taskCount = actIssue.tasks.length;
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }
}

export class activeIssue {
  issues: any = [];
  tasks: any = [];
}



// WEBPACK FOOTER //
// ./src/pages/plan-of-care/active-issues/active-issues.ts